import Call4Impact from './container';

export default Call4Impact;



// WEBPACK FOOTER //
// ./src/components/Cards/Call4ImpactCard/index.js